export default {
  ru: {
    menu: {
      title_1: 'Привлечение клиентов',
      title_2: 'Создание команды',
      title_3: 'Подключение бизнесов',
      btn: 'Зарегистрироваться',
      login: 'Войти'
    },
    connect: {
      title: 'Подключение бизнесов',
      dsc: `Это ваш собственный масштабный бизнес на уровне B2B. Работайте с крупными торговыми сетями, ресторанами, салонами, сервисами, известными брендами и обычными магазинами и зарабатывайте на их прибыли. Этот вид бизнеса можно объединять с привлечением клиентов и построением партнерской команды, создавая еще более устойчивую и доходную бизнес-систему.`,
      btn: 'Начать подключать'
    },
    dsc: {
      title: 'Как это работает?',
      paragraph: `Вы приглашаете для регистрации на кэшбэк-платформу онлайн и офлайн-бизнесы и получаете проценты от агентской комиссии данного бизнеса.`
    },
    benefit: {
      shops: {
        title: 'Почему это выгодно \n бизнесам?',
        dsc: `Магазины получают доступ к мощному онлайн-ресурсу, на котором зарегистрировано более 850 000 потенциальных покупателей, к сайту с 2 000 000 просмотров в месяц, к бесплатным каналам и инструментам для рекламы.`,
        subtitle: 'В результате у бизнеса:',
        ol: [
          'Новые клиенты',
          'Высокая прибыль',
          `Оптимизированный рекламный бюджет и возросшая доля присутствия на рынке`,
          `Возможность иметь уникальную систему лояльности для своих клиентов`
        ]
      },
      you: {
        title: 'Почему это выгодно вам?',
        dsc: `Вы обеспечиваете себе выгодные покупки, кэшбэк и скидки в том магазине, ресторане, салоне, который вам нравится.`,
        subtitle: `Рекомендуете его друзьям и получаете бонусы от их кэшбэка.`,
        dsc2: `Плюс зарабатываете на общем обороте подключенного вами бизнеса на платформе SWITIPS. Вознаграждение приходит за всех, кто делает покупки, даже если этих клиентов пригласили не вы. `,
        dsc3: `Чем больше бизнесов вы подключаете, тем больше ваша прибыль.`,
        btn: 'Зарегистрироваться'
      },
      other: {
        dsc: `Для этого вида бизнеса нужна мини-франшиза. В ее состав уже входит полноценное обучение работе с магазинами, салонами, сервисами, ресторанами, чтобы вы строили эффективный бизнес и получали реальный доход с первого дня.`
      }
    }

  },
  en: {
    menu: {
      title_1: 'Attracting customers',
      title_2: 'Creating a team',
      title_3: 'Business Connection',
      btn: 'Sign up',
      login: 'Sign in'
    },
    connect: {
      title: 'Business Connection',
      dsc: `This is your own large-scale business at the B2B level. Work with large retail chains, restaurants, salons, services, well-known brands and ordinary shops and earn on their profits. This type of business can be combined with customer acquisition and building an affiliate team, creating an even more stable and profitable business system.`,
      btn: 'Start connecting'
    },
    dsc: {
      title: 'How it works?',
      paragraph: `You invite online and offline businesses to register on the cashback platform and receive interest from the agency commission of this business.`
    },
    benefit: {
      shops: {
        title: 'Why is it beneficial to the business?',
        dsc: `Shops get access to a powerful online resource, where more than 850,000 potential buyers are registered, a site with 2,000,000 views per month, free advertising channels and tools.`,
        subtitle: 'As a result, the business has:',
        ol: [
          'New customers',
          'High profit',
          `low advertising budget and a large part of market presence`,
          `The ability to have a unique loyalty system for their customers`
        ]
      },
      you: {
        title: 'Why is it beneficial to you?',
        dsc: `You provide yourself with profitable purchases, cashback and discounts in the store, restaurant, salon that you like.`,
        subtitle: `Recommend it to your friends and get bonuses from their cashback.`,
        dsc2: `Plus, you earn on the total turnover of your connected business on the SWITIPS platform. The reward comes for everyone who makes purchases, even if these customers were not invited by you.`,
        dsc3: `The more businesses you connect, the greater your profit.`,
        btn: 'Sign up'
      },
      other: {
        dsc: `This type of business needs a mini-franchise. It already includes full-fledged training in working with shops, salons, services, restaurants, so that you build an effective business and receive real income from the first day.`
      }
    }

  },
  ua: {
    menu: {
      title_1: 'Залучення клієнтів',
      title_2: 'Створення команди',
      title_3: 'Підключення бізнесів',
      btn: 'Зареєструватися',
      login: 'Увійти'
    },
    connect: {
      title: 'Підключення бізнесів',
      dsc: `Це ваш власний масштабний бізнес на рівні B2B. Працюйте з великими торговельними мережами, ресторанами, салонами, сервісами, відомими брендами і звичайними магазинами і заробляйте на їх прибутку. Цей вид бізнесу можна об'єднувати із залученням клієнтів і побудовою партнерської команди, створюючи ще більш стійку і прибуткову бізнес-систему.`,
      btn: 'Почати підключати'
    },
    dsc: {
      title: 'Як це працює?',
      paragraph: `Ви запрошуєте для реєстрації на Кешбек-платформу онлайн і офлайн-бізнеси і отримуєте відсотки від агентської комісії даного бізнесу.`
    },
    benefit: {
      shops: {
        title: 'Чому це вигідно \n бізнесам?',
        dsc: `Магазини отримують доступ до потужного онлайн-ресурсу, на якому зареєстровано більше 850 000 потенційних покупців, до сайту з 2 000 000 переглядів в місяць, до безкоштовних каналів і інструментів для реклами.`,
        subtitle: 'В результаті у бізнеса:',
        ol: [
          'Нові клієнти',
          'Високий прибуток',
          `Оптимізований рекламний бюджет і зростає частка присутності на ринку`,
          'Можливість мати унікальну систему лояльності для своїх'
        ]
      },
      you: {
        title: 'Чому це вигідно вам?',
        dsc: `Ви забезпечуєте собі вигідні покупки, Кешбек і знижки в тому магазині, ресторані, салоні, який вам подобається.`,
        subtitle: `Рекомендуєте його друзям і отримуєте бонуси від їх Кешбек.`,
        dsc2: `Плюс заробляєте на загальному обороті підключеного вами бізнесу на платформі SWITIPS. Винагорода приходить за всіх, хто робить покупки, навіть якщо цих клієнтів запросили не ви.`,
        dsc3: `Чим більше бізнесів ви підключаєте, тим більше ваша прибуток.`,
        btn: 'Зареєструватися'
      },
      other: {
        dsc: `Для цього виду бізнесу потрібна міні-франшиза. До її складу вже входить повноцінне навчання роботі з магазинами, салонами, сервісами, ресторанами, щоб ви будували ефективний бізнес і отримували реальний дохід з першого дня.`
      }
    }

  },
  kz: {
    menu: {
      title_1: 'Клиенттерді тарту',
      title_2: 'Команда құру',
      title_3: 'Іскерлік байланыс',
      btn: 'Тіркелу',
      login: 'Кіру'
    },
    connect: {
      title: 'Іскерлік байланыс',
      dsc: `Бұл B2B деңгейіндегі сіздің жеке бизнесіңіз. Ірі бөлшек сауда желілерімен, мейрамханалармен, салондармен, қызметтермен, танымал брендтермен және қарапайым дүкендермен жұмыс жасаңыз және өз пайдаңызды табыңыз. Кәсіптің бұл түрін клиенттерді сатып алумен және серіктестік топ құрумен, одан да тұрақты және тиімді бизнес жүйесін құрумен біріктіруге болады.`,
      btn: 'Іскерлік байланыс бастау'
    },
    dsc: {
      title: 'Бұл қалай жұмыс істейді?',
      paragraph: `Сіз онлайн және офлайн бизнесті cashback платформасында тіркелуге және осы бизнестің агенттік комиссиясынан қызығушылық алуға шақырасыз.`
    },
    benefit: {
      shops: {
        title: 'Неліктен бұл бизнес үшін тиімді?',
        dsc: `Дүкендер 850 000-нан астам әлеуетті сатып алушылар тіркелген қуатты онлайн-ресурсқа, айына 2 000 000 көруден тұратын сайтқа, тегін арналар мен жарнамаға арналған құралдарға қол жеткізеді.`,
        subtitle: 'Бұл дүкендерге тиімді:',
        ol: [
          'Жаңа клиенттер',
          'Жоғары пайда',
          `Оңтайландырылған жарнамалық бюджет және нарықта қатысу үлесінің өсуі`,
          'Өз клиенттеріне бірегей адалдық жүйесі болу мүмкіндігі'
        ]
      },
      you: {
        title: 'Неге бұл сізге тиімді?',
        dsc: `Сіз өзіңізге ұнайтын дүкенде, мейрамханада, салонда тиімді сатып алулар, ақшаны қайтару және жеңілдіктермен қамтамасыз етесіз.`,
        subtitle: `Достарыңызға ұсыныңыз және олардың ақшаларын қайтару кезінде бонустар алыңыз`,
        dsc2: `Сонымен қатар, сіз SWITIPS платформасында қосылған бизнестің жалпы айналымынан пайда табасыз. Сыйлық сатып алушылар үшін жасалады, тіпті егер бұл клиенттер сіз шақырмаса да.`,
        dsc3: `Сіз неғұрлым көп бизнес қоссаңыз, пайдаңыз соғұрлым көп болады.`,
        btn: 'Тіркелу'
      },
      other: {
        dsc: `Бұл бизнес түріне шағын франшиза қажет. Бұл қазірдің өзінде тиімді бизнес құрып, алғашқы күннен бастап нақты кіріс алу үшін дүкендермен, салондармен, қызметтермен, мейрамханалармен жұмыс істеуді толыққанды үйретуді қамтиды.`
      }
    }

  }
}
